/**
 * Created by talhauddin on 2/17/2016.
 */
/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";
import { User } from "./user";

export class Invite implements Serializable<Invite> {
    inviteId;
    userId: User;
    email: String;
    status: String;

    deserialize(input: any) {
        input._id && (this.inviteId = input._id);
        input.user && (this.userId = input.user);
        input.email && (this.email = input.email);
        input.status && (this.status = input.status);

        return this;
    }

    constructor() {
    }
}
